export function getdata() {
	var obj = {
		
			headData: [{
					title: "行次",
					prop: "grade",
					custom: true,
					width: "100px"
				},
				{
					title: "投资企业信息",
					children:[
						{
							title: "技术成果名称",
							prop: 'sdsA_5_x_1',
							width: "250px",
							custom: true,
						},
						{
							title: '技术成果类型',
							prop: 'sdsA_5_x_2',
							width: "250px",
							custom: true,
						},
						{
							title: "技术成果编号",
							 prop: 'sdsA_5_x_3',
							 width: "250px",
							 custom: true,
						},
						{
							title: "公允价值",
							 prop: 'sdsA_5_x_4',
							 width: "250px",
							 custom: true,
						},
						{
							title: "计税基础",
							 prop: 'sdsA_5_x_5',
							 width: "250px",
							 custom: true,
						},
						{
							title: "取得股权时间",
							 prop: 'sdsA_5_x_6',
							 width: "250px",
							 custom: true,
						},
						{
							title: "递延所得",
							 prop: 'sdsA_5_x_7',
							 width: "250px",
							 custom: true,
						},
					]
				},
				{
					title: "被投资企业信息",
					children:[
						{
							title: "企业名称",
							 prop: 'sdsA_5_x_8',
							 width: "250px",
							 custom: true,
						},
						{
							title: "纳税人识别号",
							 prop: 'sdsA_5_x_9',
							 width: "250px",
							 custom: true,
						},
						{
							title: "主管税务机关",
							 prop: 'sdsA_5_x_10',
							 width: "250px",
							 custom: true,
						},
						{
							title: "与投资方是否为关联企业",
							 prop: 'sdsA_5_x_11',
							 width: "250px",
							 custom: true,
						},
					]
				},
				{
						title: "备注",
						prop: "sdsA_5_x_12",
						custom: true,
						width: "100px"
					},
			],
			tableData: [{
					grade: "1",
					disabledsdsA_5_x_1: false,
					disabledsdsA_5_x_2: false,
					disabledsdsA_5_x_3: false,
					disabledsdsA_5_x_4: false,
					disabledsdsA_5_x_5: false,
					disabledsdsA_5_x_6: false,
					disabledsdsA_5_x_7: false,
					disabledsdsA_5_x_8: false,
					disabledsdsA_5_x_9: false,
					disabledsdsA_5_x_10: false,
					disabledsdsA_5_x_11: false,
					disabledsdsA_5_x_12: false,
					sdsA_5_x_1: {
						cellCode: "sdsA_5_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_2: {
						cellCode: "sdsA_5_1_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_3: {
						cellCode: "sdsA_5_1_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_4: {
						cellCode: "sdsA_5_1_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_5: {
						cellCode: "sdsA_5_1_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_6: {
						cellCode: "sdsA_5_1_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_7: {
						cellCode: "sdsA_5_1_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_8: {
						cellCode: "sdsA_5_1_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_9: {
						cellCode: "sdsA_5_1_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_10: {
						cellCode: "sdsA_5_1_10",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_11: {
						cellCode: "sdsA_5_1_11",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_12: {
						cellCode: "sdsA_5_1_12",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					grade: "2",
					disabledsdsA_5_x_1: false,
					disabledsdsA_5_x_2: false,
					disabledsdsA_5_x_3: false,
					disabledsdsA_5_x_4: false,
					disabledsdsA_5_x_5: false,
					disabledsdsA_5_x_6: false,
					disabledsdsA_5_x_7: false,
					disabledsdsA_5_x_8: false,
					disabledsdsA_5_x_9: false,
					disabledsdsA_5_x_10: false,
					disabledsdsA_5_x_11: false,
					disabledsdsA_5_x_12: false,
					sdsA_5_x_1: {
						cellCode: "sdsA_5_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_2: {
						cellCode: "sdsA_5_2_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_3: {
						cellCode: "sdsA_5_2_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_4: {
						cellCode: "sdsA_5_2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_5: {
						cellCode: "sdsA_5_2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_6: {
						cellCode: "sdsA_5_2_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_7: {
						cellCode: "sdsA_5_2_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_8: {
						cellCode: "sdsA_5_2_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_9: {
						cellCode: "sdsA_5_2_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_10: {
						cellCode: "sdsA_5_2_10",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_11: {
						cellCode: "sdsA_5_2_11",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_12: {
						cellCode: "sdsA_5_2_12",
						cellType: "1",
						cellVal: "240040043.08"
					},
					
				}, {
					grade: "3",
					disabledsdsA_5_x_1: false,
					disabledsdsA_5_x_2: false,
					disabledsdsA_5_x_3: false,
					disabledsdsA_5_x_4: false,
					disabledsdsA_5_x_5: false,
					disabledsdsA_5_x_6: false,
					disabledsdsA_5_x_7: false,
					disabledsdsA_5_x_8: false,
					disabledsdsA_5_x_9: false,
					disabledsdsA_5_x_10: false,
					disabledsdsA_5_x_11: false,
					disabledsdsA_5_x_12: false,
					sdsA_5_x_1: {
						cellCode: "sdsA_5_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_2: {
						cellCode: "sdsA_5_3_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_3: {
						cellCode: "sdsA_5_3_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_4: {
						cellCode: "sdsA_5_3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_5: {
						cellCode: "sdsA_5_3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_6: {
						cellCode: "sdsA_5_3_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_7: {
						cellCode: "sdsA_5_3_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_8: {
						cellCode: "sdsA_5_3_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_9: {
						cellCode: "sdsA_5_3_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_10: {
						cellCode: "sdsA_5_3_10",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_11: {
						cellCode: "sdsA_5_3_11",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_12: {
						cellCode: "sdsA_5_3_12",
						cellType: "1",
						cellVal: "240040043.08"
					},
					
				}, {
					title: "其他",
					grade: "4",
					disabledsdsA_5_x_1: false,
					disabledsdsA_5_x_2: false,
					disabledsdsA_5_x_3: false,
					disabledsdsA_5_x_4: false,
					disabledsdsA_5_x_5: false,
					disabledsdsA_5_x_6: false,
					disabledsdsA_5_x_7: false,
					disabledsdsA_5_x_8: false,
					disabledsdsA_5_x_9: false,
					disabledsdsA_5_x_10: false,
					disabledsdsA_5_x_11: false,
					disabledsdsA_5_x_12: false,
					sdsA_5_x_1: {
						cellCode: "sdsA_5_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_2: {
						cellCode: "sdsA_5_4_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_3: {
						cellCode: "sdsA_5_4_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_4: {
						cellCode: "sdsA_5_4_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_5: {
						cellCode: "sdsA_5_4_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_6: {
						cellCode: "sdsA_5_4_6",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_7: {
						cellCode: "sdsA_5_4_7",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_8: {
						cellCode: "sdsA_5_4_8",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_9: {
						cellCode: "sdsA_5_4_9",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_10: {
						cellCode: "sdsA_5_4_10",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_11: {
						cellCode: "sdsA_5_4_11",
						cellType: "1",
						cellVal: "240040043.08"
					},
					sdsA_5_x_12: {
						cellCode: "sdsA_5_4_12",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}
			]
	}
	return obj
}
